<template>
	<div>
    <div class="popup_high_right one-time-topup-popup"
         :class="['level-'+level,{}]">

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Choose an amount to add
		            <span></span>
	            </h3>

	            <div class="options">
		            <select-button v-for="o in topupOptions" v-model="amount"
		                           :value="o.id" :label="o.label" :subtitle="o.subtitle" no-icon />
	            </div>

	            <div class="margin-t-15">
		            <p>We will automatically charge <b>{{amountFormatted}}</b> to your default payment
			            method under <a href="/settings/billing"><b>Account &gt; Billing</b></a>.
			            <span v-if="bonus">Then we will add a <b>{{bonus}}</b> to your balance.</span>
		            </p>
	            </div>
	            <div style="min-height: 10px"></div>
            </div>

	    <div class="popup-actions layout-row">
		    <v-button label="Top up" @click="save" :loading="saving" />
		    <v-button label="Cancel" border @click="$emit('close')" />
	    </div>


    </div>

	</div>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import BackBtn from "@/components/base/back-btn";
import SelectButton from "@/components/base/select_button";
import numbers from "@/helpers/numbers";

export default {
	name: "one-time-topup-popup",
	mixins: [API],
	components: {
		SelectButton,
		BackBtn,
		VButton,
	},
	props:{
		level: {
			type: Number,
			default: 0,
		},
		funnelId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			editorFocused: false,
			amount: 20,

			saving: false,

			topupOptions:[
				{id:20,label:"$20"},
				{id:40,label:"$40"},
				{id:80,label:"$80"},
				{id:120,label:"$120", bonus:6, subtitle:'+ $6 BONUS'},
				{id:200,label:"$200", bonus:10, subtitle:'+ $10 BONUS'},
				{id:500,label:"$500", bonus:25, subtitle:'+ $25 BONUS'},
				{id:1000,label:"$1,000", bonus:100, subtitle:'+ $100 BONUS'},
				{id:2000,label:"$2,000", bonus:200, subtitle:'+ $200 BONUS'},
				{id:4000,label:"$4,000", bonus:400, subtitle:'+ $400 BONUS'},
				{id:6000,label:"$6,000", bonus:660, subtitle:'+ $660 BONUS'},
				{id:8000,label:"$8,000", bonus:880, subtitle:'+ $880 BONUS'},
				{id:10000,label:"$10,000", bonus:1100, subtitle:'+ $1,100 BONUS'},
			],
		}
	},
	computed:{
		amountFormatted(){
			return "$"+numbers.numberWithCommas(this.amount)
		},
		bonus() {
			let b = this.topupOptions.find(x=>x.id===this.amount)
			if (!b || !b.bonus) return 0;
			return "$"+numbers.numberWithCommas(b.bonus);
		}
	},
	methods: {

		closePopup() {
			this.$emit('close')
		},
		async save() {
			try {
				this.saving = true;

				let r = await this.api.sms.topUp({amount:this.amount});
				if (r.error) {
					this.$error(r.error, !!r.info.data ? r.info.data.error : '');
				}
				else {
					this.$info(null, `${this.amountFormatted} Top up completed.`)
					this.$emit('done', r)
				}
			} catch (e) {
				console.warn("error:+",e)
				this.$error(e)
			} finally {
				this.saving = false;
			}
		}
	},
	created() {
	},
}
</script>
<style lang="scss">
.one-time-topup-popup {
	.select-button .item {
		border-radius: 4px;
		.title {
			font-weight: 500;
		}
	}
}
</style>
<style lang="scss" scoped>
.one-time-topup-popup {
	padding: 0;
	p {
		line-height: 1.5;
	}
	.options {
		margin-top: 30px;
		grid-gap: 15px;
		display: grid;
		grid-auto-flow: row;
		grid-template-columns: 150px 150px 150px;
	}
	.popup-actions {
		padding: 10px 30px;
		border-top: 1px solid $light-grey;
		.button {
			margin-right: 25px;
		}
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.order-status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}
}
.popup_title {
	font-size: 20px;
}
</style>
